// APP 
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const ADD_VISITED_VIEWS = "ADD_VISITED_VIEWS";
export const DEL_VISITED_VIEWS = "DEL_VISITED_VIEWS";

// user
export const RECEIVE_ADMIN_ID = "RECEIVE_ADMIN_ID"; // user ID
export const RECEIVE_ADMIN_TOKEN = "RECEIVE_ADMIN_TOKEN"; // token
export const RECEIVE_ADMIN_NAME = "RECEIVE_ADMIN_NAME"; // nickname
export const RECEIVE_ADMIN_AVATAR = "RECEIVE_ADMIN_AVATAR"; // head portrait
export const RECEIVE_ADMIN_AUTH_RULES = "RECEIVE_ADMIN_AUTH_RULES"; // Permission list
export const RECEIVE_ADMIN_AUTH_BRANDID = "RECEIVE_ADMIN_AUTH_BRANDID"; // BrandId
export const RECEIVE_ROUTERS = "RECEIVE_ROUTERS"; // Initialize routing table